import CrmTable from './crm-table'
export { CrmTable }
